import { useState, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import CloseX from 'components/icons/navigation/CloseX';
import { getCookie, setCookie } from 'utilities/cookies';

export const PrivacyPolicyChange = () => {
  const PRIVACY_POLICY_FEB_2026 = 'privacyPolicyChangeFeb2026';
  const nodeRef = useRef(null);

  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!getCookie(PRIVACY_POLICY_FEB_2026)) {
      setShown(true);
      setCookie(PRIVACY_POLICY_FEB_2026, 'true');
    }
  }, []);

  const handleClose = () => {
    setShown(false);
  };

  return (
    <CSSTransition
      classNames="scaleHeight"
      nodeRef={nodeRef}
      in={shown}
      timeout={200}
      unmountOnExit
    >
      <div
        ref={nodeRef}
        className="relative w-full bg-charcoal-100 py-4 pl-8 pr-12 text-left text-white-100"
      >
        <p className="textSm font-normal">
          To provide and personalize our offerings, make recommendations, detect and prevent fraud,
          and improve our services, we use tools that collect and record your data, and may share
          non-sensitive data with third parties, such as advertising and analytics vendors, social
          networks, technology providers and research providers. By continuing to use our websites
          and apps, this means you accept our{' '}
          <a
            href="https://www.homechef.com/terms"
            target="_blank"
            rel="noopener"
            className="text-white-100 underline transition-all hover:font-semibold hover:text-white-100 focus:font-semibold focus:text-white-100"
          >
            Terms
          </a>{' '}
          and our{' '}
          <a
            href="https://cook.homechef.com/privacy-policy"
            target="_blank"
            rel="noopener"
            className="text-white-100 underline transition-all hover:font-semibold hover:text-white-100 focus:font-semibold focus:text-white-100"
          >
            Privacy Policy
          </a>
          .
          <button
            className="pt-xs absolute bottom-0 right-0 top-0 flex appearance-none items-center border-none bg-transparent p-5 transition-all hover:text-charcoal-70 focus:text-charcoal-70"
            onClick={handleClose}
          >
            <CloseX className="h-6 w-6" />
            <span className="sr">Close this banner permanently</span>
          </button>
        </p>
      </div>
    </CSSTransition>
  );
};

export default PrivacyPolicyChange;
